import React from "react";
import styles from "./styles/CreateGame.module.css";
import useTranslation from "next-translate/useTranslation";
import Button from "../../components/Button";
import GameButton, { BUTTON_TYPE_CUSTOM } from "./GameButton";
import { doCreateGame, lobbyStore, useLobby } from "../../ducks/lobby";
import { VARIANT_CHESS960, VARIANT_CHESS } from "@chesshotel/constants";
import { settingsStore } from "../../ducks/settings";
import { websocket } from "../../services/websocket";

const BUTTONS = [
  { time: 1, inc: 0, variant: VARIANT_CHESS },
  { time: 2, inc: 1, variant: VARIANT_CHESS },
  { time: 3, inc: 0, variant: VARIANT_CHESS },
  { time: 5, inc: 0, variant: VARIANT_CHESS },
  { time: 5, inc: 2, variant: VARIANT_CHESS },
  { time: 10, inc: 0, variant: VARIANT_CHESS },
  { time: 15, inc: 0, variant: VARIANT_CHESS },
  { time: 8, inc: 0, variant: VARIANT_CHESS960 },
];

export function createQuickMatch() {
  const { minOpponentRating, maxOpponentRating, noGuests } =
    settingsStore.getState();

  const {
    time,
    inc,
    variant,
    modeId,
    leaguePlay,
    gamesCreated,
    filterGuestUsername,
  } = lobbyStore.getState();

  const game = {
    time,
    inc,
    minElo: minOpponentRating,
    maxElo: maxOpponentRating,
    variant,
    leaguePlay,
    modeId,
    noGuests,
    noGuestName: filterGuestUsername,
  };

  websocket.emit("quik", game);

  let gameCreated = false;
  gamesCreated.forEach((game) => {
    if (time === game.time && inc === game.inc && variant === game.variant) {
      gameCreated = true;
    }
  });
  if (!gameCreated) {
    doCreateGame({ time, inc, variant });
  }
}

export default function CreateGame() {
  const { customTime, customInc, customVariant } = useLobby();
  const { t } = useTranslation("common");

  return (
    <div className={styles.lobby}>
      <div className={styles.lobbyInner}>
        <div className={styles.row}>
          <GameButton
            time={BUTTONS[0].time}
            inc={BUTTONS[0].inc}
            variant={BUTTONS[0].variant}
            timeType="Bullet"
          />
          <GameButton
            time={BUTTONS[1].time}
            inc={BUTTONS[1].inc}
            variant={BUTTONS[1].variant}
            timeType="Bullet"
          />
          <GameButton
            time={BUTTONS[2].time}
            inc={BUTTONS[2].inc}
            variant={BUTTONS[2].variant}
            timeType="Blitz"
          />
        </div>
        <div className={styles.row}>
          <GameButton
            time={BUTTONS[3].time}
            inc={BUTTONS[3].inc}
            variant={BUTTONS[3].variant}
            timeType="Blitz"
          />
          <GameButton
            time={BUTTONS[4].time}
            inc={BUTTONS[4].inc}
            variant={BUTTONS[4].variant}
            timeType="Blitz"
          />
          <GameButton
            time={BUTTONS[5].time}
            inc={BUTTONS[5].inc}
            variant={BUTTONS[5].variant}
            timeType="Rapid"
          />
        </div>
        <div className={styles.row}>
          <GameButton
            time={BUTTONS[6].time}
            inc={BUTTONS[6].inc}
            variant={BUTTONS[6].variant}
            timeType="Rapid"
          />
          <GameButton
            time={BUTTONS[7].time}
            inc={BUTTONS[7].inc}
            timeType="Chess960"
            variant={BUTTONS[7].variant}
          />
          <GameButton
            type={BUTTON_TYPE_CUSTOM}
            time={customTime}
            inc={customInc}
            variant={customVariant}
            timeType={t("Custom")}
          />
        </div>
      </div>
      <div className={styles.createGameBtn}>
        <Button onClick={() => createQuickMatch()}>{t("Send")}</Button>
      </div>
    </div>
  );
}
